import { useController } from '../../hooks/useController'
import { useShowOutOfStorageSpaceModal } from '../../hooks/useShowOutOfStorageSpaceModal'

import { OperationalStorageTipsFooter } from './components/OperationalStorageTipsFooter'
import { OperationalWarningFooter } from './components/OperationalWarningFooter'
import { SimulationWarningFooter } from './components/SimulationWarningFooter'

export function Footer() {
  const {
    data: { wizardStep, isSimulation },
  } = useController()

  const { acknowledgeModal } = useShowOutOfStorageSpaceModal()

  if (isSimulation) {
    return <SimulationWarningFooter acknowledgeModal={acknowledgeModal} />
  }

  switch (wizardStep) {
    case 'warning':
      return <OperationalWarningFooter acknowledgeModal={acknowledgeModal} />

    case 'storage-tips':
      return <OperationalStorageTipsFooter acknowledgeModal={acknowledgeModal} />

    default:
      throw new Error(`unhandled wizard step: ${wizardStep}`)
  }
}
